import { render, staticRenderFns } from "./grid-table.vue?vue&type=template&id=d8026138"
import script from "./grid-table.vue?vue&type=script&lang=js"
export * from "./grid-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThumbnailProduct: require('/usr/src/app/components/thumbnail/product.vue').default})
